import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { VentaService } from '../../../services/venta.service';
import { Venta } from './../../../models/venta';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Pagination } from '../../../models/pagination';

@Component({
  selector: 'venta-filter-modal',
  templateUrl: './venta-filter-modal.component.html',
  styleUrls: ['./venta-filter-modal.component.css'],
  providers: [ VentaService ]
})
export class VentaFilterModalComponent implements OnInit {
	@Output() onSelectedRow = new EventEmitter();
	@Input() qs = "";
	@Input() numero_decimales: number = 2;
	public ventas: Array<Venta> = [];
	public selectedRow: Number;
	public venta: Venta;
	public pagination: Pagination;
	public loading = false;
	public format_decimal: String;
	public text: String;

	constructor(
		public VentaService: VentaService,
		public bsModalRef: BsModalRef,
	) {
		this.ventas = [];
		this.venta = new Venta();
		this.pagination = new Pagination();
		this.format_decimal = "0,0.00";
		this.text="";
    }

	ngOnInit() {
		let digitos = "";
		for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
		this.format_decimal = "0,0." + digitos;

		this.getVentas();
	}

	getVentasBySearch(text){
		this.text = text;
		let qs = "&razon_social="+this.text+"&nombre_comercial="+this.text;
		this.pagination.current_page = 1;
		this.getVentas(qs);
	}

	getVentas(qs = ""){
		this.loading = true;
		this.VentaService.getAllByFilter("?page="+this.pagination.current_page+"&per_page=10"+qs).subscribe(
			res => {
				this.loading = false;
				this.ventas = res.data;
				this.pagination.current_page = res.current_page;
				this.pagination.from = res.from;
				this.pagination.to = res.to;
				this.pagination.total = res.total;
				this.pagination.last_page = res.last_page;
				this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
				this.pagination.prev_disabled = this.pagination.current_page === 1;
			},
			err => {
				this.loading = false;
				this.ventas = [];
			}
		);
	}

	numeroFactura(venta){
        return venta.serie + "-" + venta.punto_emision + "-" + venta.secuencial;
	}
	
	parseTipo(tipo){
		if( tipo === "CR" ){
			return "Crédito";
		}else{
			return "Contado";
		}
	}

	onSelectRow(venta, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de usuario
		this.venta = venta;
	}

	onDBLClick(usuario,i){
		this.onSelectRow(usuario,i);
		this.onSubmit();
	}

	onSubmit() {
		//envía de objecto usuario
		this.onSelectedRow.emit(this.venta);
		//Cierre de modal o componente
		this.bsModalRef.hide();
	}

	next(){
		
		let qs = "&razon_social="+this.text+"&nombre_comercial="+this.text;

		this.pagination.current_page++;
		this.getVentas(qs);
	}

	prev(){
		
		let qs = "&razon_social="+this.text+"&nombre_comercial="+this.text;

		this.pagination.current_page--;
		this.getVentas(qs);
	}

	first(){
		
		let qs = "&razon_social="+this.text+"&nombre_comercial="+this.text;

		this.pagination.current_page = 1;
		this.getVentas(qs);
	}

	last(){
		
		let qs = "&razon_social="+this.text+"&nombre_comercial="+this.text;

		this.pagination.current_page = this.pagination.last_page;
		this.getVentas(qs);
	}

	get formatDecimal(){
        return this.format_decimal;
	}

	getIndexNumber(i){
        return this.pagination.from+i;
	}
}




// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/venta-filter-modal/venta-filter-modal.component.ts